import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

export default function Results({ results }) {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [products, setProducts] = useState([]);

  const getSuggestions = async () => {
    setLoading(true);
    let newData = [];
    let productData = [];
    console.log("RESULTADOS",results);

    results.forEach((result) => {
      const newObject = {};
      newObject.name = result.step;
      newObject.results = [];

      result.answers.forEach((answer) => {
        const peso = answer.weight;

        answer.values.forEach((value) => {
          if (!newObject.results.find((r) => r.name === value)) {
            newObject.results.push({ name: value, value: 0 });
          }
          newObject.results.find((r) => r.name === value).value += 1 * peso;
        });
      });

      newObject.results = newObject.results.sort((a, b) => b.value - a.value);

      newData.push(newObject);
    });

    for (let i = 0; i < newData.length; i++) {
      const iterations = newData[i].results.slice(
        0,
        results[i].numeroResultados
      );

      let productArray = [];

      for (let j = 0; j < iterations.length; j++) {
        const handle = results[i].dictionary[iterations[j].name];

        console.log("iterations", handle);


        const response = await (
          await fetch(
            `https://blends-botanicare.myshopify.com/api/2022-07/graphql.json`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-Shopify-Storefront-Access-Token":
                  "5785cbbf86572c516a47bcff7c0baa5e",
              },
              body: JSON.stringify({
                query: `
              query getProductFromHandle ($handle: String!) {
                productByHandle(handle: $handle) {
                  title
                  featuredImage {
                    url(transform: {maxWidth: 600})
                  }
                  onlineStoreUrl
                }
              }
            `,
                variables: {
                  handle,
                },
              }),
            }
          )
        ).json();

        productArray.push({
          title: response.data.productByHandle.title,
          image: response.data.productByHandle.featuredImage.url,
          url: `/products/${handle}`,
        });

        if(handle.includes("shampoo")){
          //ver que shampoo es
          
          console.log("shampoo", handle);
          if(handle == "shampoo-anti-caida-detox"){
            console.log("entre al handle")
            const response = await (
              await fetch(
                `https://blends-botanicare.myshopify.com/api/2022-07/graphql.json`,
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    "X-Shopify-Storefront-Access-Token":
                      "5785cbbf86572c516a47bcff7c0baa5e",
                  },
                  body: JSON.stringify({
                    query: `
                  query getProductFromHandle {
                    productByHandle(handle: "acondicionador-fortificante-crecimiento") {
                      title
                      featuredImage {
                        url(transform: {maxWidth: 600})
                      }
                      onlineStoreUrl
                    }
                  }
                `
                  }),
                }
              )
            ).json();
            productArray.push({
              title: response.data.productByHandle.title,
              image: response.data.productByHandle.featuredImage.url,
              url: `/products/${handle}`,
            });
          }
          if(handle == "shampoo-anti-caida-ultra-hidratacion"){
            console.log("entre al handle")
            const response = await (
              await fetch(
                `https://blends-botanicare.myshopify.com/api/2022-07/graphql.json`,
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    "X-Shopify-Storefront-Access-Token":
                      "5785cbbf86572c516a47bcff7c0baa5e",
                  },
                  body: JSON.stringify({
                    query: `
                  query getProductFromHandle {
                    productByHandle(handle: "acondicionador-fortificante-hidratacion-anti-frizz") {
                      title
                      featuredImage {
                        url(transform: {maxWidth: 600})
                      }
                      onlineStoreUrl
                    }
                  }
                `
                  }),
                }
              )
            ).json();
            productArray.push({
              title: response.data.productByHandle.title,
              image: response.data.productByHandle.featuredImage.url,
              url: `/products/${handle}`,
            });
          }
          if(handle == "shampoo-anti-caida-reparacion-extrema"){
            console.log("entre al handle")
            const response = await (
              await fetch(
                `https://blends-botanicare.myshopify.com/api/2022-07/graphql.json`,
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    "X-Shopify-Storefront-Access-Token":
                      "5785cbbf86572c516a47bcff7c0baa5e",
                  },
                  body: JSON.stringify({
                    query: `
                  query getProductFromHandle {
                    productByHandle(handle: "acondicionador-fortificante-reparacion-extrema") {
                      title
                      featuredImage {
                        url(transform: {maxWidth: 600})
                      }
                      onlineStoreUrl
                    }
                  }
                `
                  }),
                }
              )
            ).json();
            productArray.push({
              title: response.data.productByHandle.title,
              image: response.data.productByHandle.featuredImage.url,
              url: `/products/${handle}`,
            });
          }


          const responseCrema = await (
            await fetch(
              `https://blends-botanicare.myshopify.com/api/2022-07/graphql.json`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "X-Shopify-Storefront-Access-Token":
                    "5785cbbf86572c516a47bcff7c0baa5e",
                },
                body: JSON.stringify({
                  query: `
                query getProductFromHandle {
                  productByHandle(handle: "crema-para-peinar-fortificante") {
                    title
                    featuredImage {
                      url(transform: {maxWidth: 600})
                    }
                    onlineStoreUrl
                  }
                }
              `
                }),
              }
            )
          ).json();
          productArray.push({
            title: responseCrema.data.productByHandle.title,
            image: responseCrema.data.productByHandle.featuredImage.url,
            url: `/products/${handle}`,
          })
          

        }
      }

      productData.push(productArray);
    }

    console.log("fetched: ", productData);

    setProducts(productData);
    setData(newData);
    setLoading(false);
  };

  useEffect(() => {
    if (!data) {
      getSuggestions();
    }
  }, [results, data]);

  return (
    <motion.div
      initial={{ x: 300, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      exit={{ x: -300, opacity: 0 }}
    >
      <h1>Resultados</h1>
      <p>
        <strong>
          Te presentamos el Ritual Natural Blends Botanicare que eleva tu
          belleza.
        </strong>
        <br />
        Te recomendamos incluir el sistema completo para mejores resultados.
      </p>
      {loading ? (
        <div>
          <p>Loading...</p>
        </div>
      ) : (
        <div>
          <div className="recomendations_container">
            {products[0].map((product) => (
              <div className="recomendation">
                <a href={product.url} target="_blank" rel="noopener">
                  <img src={product.image} alt={product.title} />
                  <p
                    style={{
                      textDecoration: "none",
                      color: "var(--text-color)",
                    }}
                  >
                    {product.title}
                  </p>
                  Ver producto
                </a>
              </div>
            ))}
            {products[1].map((product) => (
              <div className="recomendation">
                <a href={product.url} target="_blank" rel="noopener">
                  <img src={product.image} alt={product.title} />
                  <p
                    style={{
                      textDecoration: "none",
                      color: "var(--text-color)",
                    }}
                  >
                    {product.title}
                  </p>
                  Ver producto
                </a>
              </div>
            ))}
            {products[2].map((product) => (
              <div className="recomendation">
                <a href={product.url} target="_blank" rel="noopener">
                  <img src={product.image} alt={product.title} />
                  <p
                    style={{
                      textDecoration: "none",
                      color: "var(--text-color)",
                    }}
                  >
                    {product.title}
                  </p>
                  Ver producto
                </a>
              </div>
            ))}
          </div>
        </div>
      )}
    </motion.div>
  );
}
